/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_ORGANIZATION_PROFILE: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.organizationProfilePage.getOrganizationProfile',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_ORGANIZATION_PROFILE' },
      },
    },
    GET_ORGANIZATION_PROFILE: {
      invoke: {
        id: 'getOrganizationProfile',
        src: 'getOrganizationProfile',
        onDone: {
          target: 'RENDER_ORGANIZATION_PROFILE',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_ORGANIZATION_PROFILE_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ORGANIZATION_PROFILE: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_ORGANIZATION_PROFILE',
        },
      },
    },
    RENDER_ORGANIZATION_PROFILE_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
